/* eslint-disable */
export function format(symbol, num) {
  num = +num
  symbol = symbol || ''
  return function(num) {
    if (num === 0) return '0'
    if (Math.abs(num) >= 1000000) {
      num = Math.round(num/10000)/100
      num = num.toLocaleString('en-US')
      num += 'M'
    }
    else {
      num = num.toLocaleString('en-US')
    }
    return `${symbol}${num}`
  }
}
/* eslint-enable */

export function getExtents(data, names, chart_id, constVal) {
  let min = Infinity, max = null
  data.map(row => {
    let values = []
    if (chart_id) {
      names.map(name => {
        if (row.indicators && row.indicators[chart_id] && row.indicators[chart_id][name]) {
          values.push(row.indicators[chart_id][name])
        }
      })
    } else {
      names.map(name => {
        if (typeof row[name] === 'number') {
          values.push(row[name])
        }
      })
    }
    min = Math.min.apply(Math, [...values, min])
    max = Math.max.apply(Math, [...values, max])
    if (constVal) {
      min = Math.min(min, constVal)
      max = Math.max(max, constVal)
    }
  })
  if (max > 0 && min === max) {
    min = 0
  }
  if (min < 0 && max === min) {
    max = 0
  }
  const diff = max - min
  let tickValue = Math.floor(diff/5)
  tickValue = Math.ceil(tickValue/5)*5
  let digits = tickValue.toString().length - 1
  let round
  if (digits === 0) {
    round = 5
  } else {
    round = Math.pow(10, (digits))
  }
  tickValue = Math.floor(tickValue/round)*round
  if (tickValue < 1) {
    return [min, max]
  }
  min = Math.floor(min/tickValue)*tickValue
  max = Math.ceil(max/tickValue)*tickValue
  if (constVal === min) {
    min -= tickValue
  }
  if (constVal === max) {
    max += tickValue
  }

  return [min, max]
}
